/* eslint-disable import/no-unresolved */
import { Tabs, PageHeader } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useWorkspaceStore } from '../store/workspace.store';

const { TabPane } = Tabs;

const Settings: FC = () => {
    const { t: tp } = useTranslation('shared', { keyPrefix: 'PAGES' });

    const workspace = useWorkspaceStore((state) => state.data);

    const navigate = useNavigate();
    const { '*': currentRoute } = useParams();

    const { tabs, routes } = useMemo(() => {
        const options = [
            { key: 0, label: 'General', route: 'general' },
        ];

        const routes = options.map((option) => option.route);

        return {
            tabs: options,
            routes,
        };
    }, []);

    const activeTab = routes.findIndex((route) => route === currentRoute);

    const handleChangeTab = (index: string) => {
        navigate(`/settings/${routes[parseInt(index, 10)]}`);
    };

    return (
        <div className="screen">
            <PageHeader
                title={`${tp('SETTINGS')} | ${workspace?.name}`}
                style={{ padding: 0 }}
                footer={(
                    <Tabs
                        activeKey={activeTab.toString()}
                        onChange={handleChangeTab}
                    >
                        {
                            tabs.map((tab, index) => (
                                <TabPane
                                    tab={tab.label}
                                    key={index.toString()}
                                />
                            ))
                        }
                    </Tabs>
                )}
            />
        </div>
    );
};

export { Settings };
